import { render } from "./OtherPaymentInstructions.vue?vue&type=template&id=908b8bfa&scoped=true"
import script from "./OtherPaymentInstructions.vue?vue&type=script&lang=js"
export * from "./OtherPaymentInstructions.vue?vue&type=script&lang=js"

import "./OtherPaymentInstructions.vue?vue&type=style&index=0&id=908b8bfa&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908b8bfa"]])

export default __exports__